import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import useOpenIncidentChart from "./useOpenIncidentChart";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  interaction: {
    mode: "index" as const,
    intersection: false,
  },
  plugins: {
    legend: {
      display: false,
    },
  },
};

const OpenIncidentChart = ({ data }: any) => {
  const { chartData } = useOpenIncidentChart({ data });
  return <Bar options={options} data={chartData} />;
};

export default OpenIncidentChart;
